import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import DocumentEdit from '../controls/DocumentEdit';
import ProtocolEdit from '../controls/ProtocolEdit';
import ProjectEdit from '../controls/ProjectEdit';
import OtherEdit from '../controls/OtherEdit';
import ModalInput from '../controls/ModalInput';


const ObjectPage = (props) => {
    let [requestTypeId, setRequestTypeId] = useState();
    let [data, setData] = useState({});
    let [objectId, setObjectId] = useState();
    let [newActivity, setNewActivity] = useState(false);
    let [inNum, setInNum] = useState();
    let [reloadId, setReloadId] = useState();
    let [acstreModalVisible, setAcstreModalVisible] = useState(false);
    let [acstreNum, setAcstreNum] = useState();

    const requestId = sessionStorage.getItem("requestId");
    const changeData = (fieldName, value) => {
        data[fieldName] = value;
        setData({ ...data });
    }

    const sendToSIS = () => {
        let sd = {
            requestId: objectId,
            numName: inNum
        };
        Comm.Instance().post('requestSendToSys', sd).then(result => {
            toast.info("Преписката е изпратена към СИС");
        }).catch(error => Tools.ProcessError(error))

    }

    const saveAcstreNum = (x) => {

        data = {
            requestId: parseInt(props.match.params.requestId),
            acstreNum: x || ""
        };
        Comm.Instance().post('requestacstrenum', data).then(result => {            
            setAcstreModalVisible(false);
            setAcstreNum(x || "");
            toast.info("Номерът е записан");
        }).catch(error => Tools.ProcessError(error))


    };

    useEffect(() => {
        async function fetchData() {
            if (!props.match.params.requestId)
                return;

            Comm.Instance().get(`request?requestId=${props.match.params.requestId}`).then(result => {

                setData(JSON.parse(result.data.data));
                setObjectId(result.data.requestId)
                setRequestTypeId(result.data.requestTypeId)
                setInNum(result.data.numName);
                setAcstreNum(result.data.acstreNum)

            }).catch(error => Tools.ProcessError(error))
        };
        fetchData();
    }, []);





    const createObject = () => {

        Comm.Instance().post("specialrequest", {
            requestId: objectId,
            title: data.title,
            data: JSON.stringify(data),
            requestTypeId: requestTypeId
        })
            .then(r => {
                sessionStorage.setItem("requestId", r.data.id);
                setObjectId(r.data.id);
                setInNum(r.data.num);
                if (!props.match.params.requestId) {
                    setReloadId(r.data.id);
                }
            })
    }

    if (reloadId) {
        return (<Redirect to={"RequestMain/" + reloadId} />);

    }

    if (newActivity) {
        return <Redirect to="/RequestActivities" />
    }


    if (!requestTypeId) {
        return (
            <div className="container">
                <h2 className="appeal-title mb-5">Изберете тип преписка</h2>

                <div className="form-row">
                    <div className="form-group col-md-3">
                        <button type="button" className="btn btn-primary" onClick={() => setRequestTypeId(10)}>Нов протокол</button>
                    </div>
                    <div className="form-group col-md-3">
                        <button type="button" className="btn btn-primary" onClick={() => setRequestTypeId(11)}>Нов проект</button>
                    </div>
                    <div className="form-group col-md-3">
                        <button type="button" className="btn btn-primary" onClick={() => setRequestTypeId(12)}>Нов документ</button>
                    </div>
                    <div className="form-group col-md-3">
                        <button type="button" className="btn btn-primary" onClick={() => setRequestTypeId(13)}>Друга преписка</button>
                    </div>

                </div>

            </div>
        );
    }
    else {
        return (
            <div className="container">


                <div className="form-row">
                    <div className="form-group col-md-12">
                        <div className="col-md-6">
                            <h1>Преписка {inNum}</h1>
                        </div>
                        <div className="col-md-6">
                            <h1>Входящ номер от АКСТЪР: {acstreNum}</h1>
                        </div>
                    </div>
                    <div className="form-group col-md-12">
                        {requestTypeId == 12 && <DocumentEdit data={data} setData={changeData} />}
                        {requestTypeId == 10 && <ProtocolEdit data={data} setData={changeData} />}
                        {requestTypeId == 11 && <ProjectEdit data={data} setData={changeData} />}
                        {requestTypeId == 13 && <OtherEdit data={data} setData={changeData} />}
                    </div>
                    <div className="form-group col-md-12">
                        <label>Допълнителни данни</label>
                        <textarea className="form-control" rows={10} value={data.notes} onChange={(e) => changeData("notes", e.target.value)} />
                    </div>
                    <div className="form-group col-md-3">
                        <button type="button" className="btn btn-primary" onClick={() => createObject()}>{objectId ? "Запис на проментите" : "Създаване на преписка"}</button>
                    </div>
                    <div className="form-group col-md-3">
                        {inNum && <button type="button" className="btn btn-success" onClick={() => sendToSIS()}>Прехвърляне в СИС</button>}
                    </div>
                    <div className="form-group col-md-3">
                        {inNum && <button type="button" className="btn btn-danger" onClick={() => setNewActivity(true)}>Нова дейност</button>}
                    </div>
                    <div className="form-group col-md-3">
                        {inNum && <button type="button" className="btn btn-success" onClick={() => setAcstreModalVisible(true)}>Вх. номер от АКСТЪР</button>}
                    </div>
                    

                </div>
                <ModalInput display={acstreModalVisible} closeFunc={() => setAcstreModalVisible(false)} saveFunc={(x) => saveAcstreNum(x)} value={data.acstreNum} dataType="text" title="Входящ номер от акстър" />

            </div>
        );
    }

}


export default ObjectPage;

